import { Button, Popover, Stack, Text, TextInput } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { primaryColor } from '../../../../constants/theme';
import { IconShare } from '@tabler/icons-react';
import { useState } from 'react';
import { DownloadQRCodeButton } from './DownloadQRCodeButton';
import { sendProfileShareMilestone } from '../../../../services/ProfileService';
import { LocalStorageKeys } from '../../../../constants/locationStorage';

const BASE_URL = import.meta.env.VITE_WEB_BASE_URL;

export const ShareProfileButton = ({
  username,
  width,
}: {
  username: string;
  width?: number;
}) => {
  const [opened, { close, open }] = useDisclosure();
  const value = `${BASE_URL}/cb/@${username || ''}`;
  const shareProfileStorageKey = `${LocalStorageKeys.SHARE_PROFILE_MILESTONE_SENT}_${
    username || 'unknown'
  }`;

  const onCopyQRCode = async () => {
    try {
      const alreadySent = localStorage.getItem(shareProfileStorageKey) === 'true';
      if (alreadySent) {
        return;
      }

      await sendProfileShareMilestone();
      localStorage.setItem(shareProfileStorageKey, 'true');
    } catch (error) {
      console.error('Share profile milestone error', error);
    }
  };

  const onCopyLink = async () => {
    setLoading(true);
    navigator.clipboard.writeText(value);
    setTimeout(() => {
      setLoading(false);
      close();
    }, 300);
  };

  const [loading, setLoading] = useState(false);

  return (
    <Popover
      closeOnClickOutside
      width={325}
      position="bottom"
      withArrow
      shadow="md"
      opened={opened}
      onChange={(opened) => {
        if (!opened) close();
      }}
    >
      <Popover.Target>
        <Button
          w={width}
          variant="outline"
          color={primaryColor}
          leftSection={<IconShare size={20} />}
          onClick={opened ? close : open}
          data-testid="share-profile-button"
        >
          Share Profile
        </Button>
      </Popover.Target>
      <Popover.Dropdown data-testid="share-profile-popover">
        <Stack gap={5}>
          <Text ta="start" size="md" data-testid="share-profile-text">
            Copy the link below to share your profile
          </Text>
          <TextInput value={value} readOnly data-testid="share-profile-input" />
          <Button
            variant="outline"
            loading={loading}
            color={primaryColor}
            onClick={onCopyLink}
            data-testid="copy-link-button"
          >
            Copy Link
          </Button>
          <DownloadQRCodeButton
            username={username}
            value={value}
            onCopyQRCode={() => {
              void onCopyQRCode();
            }}
          />
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
};
